import { useState } from "react";
import type { WizardData } from "./HierarchyManagement";

export const useWizardState = () => {
  const [wizardStep, setWizardStep] = useState(0);
  const [wizardData, setWizardData] = useState<WizardData>({});
  const [companyMode, setCompanyMode] = useState<"attach" | "create">("attach");
  const [override, setOverride] = useState<Record<string, boolean>>({});
  const [initialOverride, setInitialOverride] = useState<Record<string, boolean>>({});
  const [companyOverride, setCompanyOverride] = useState<Record<string, boolean>>({});
  const [initialCompanyOverride, setInitialCompanyOverride] = useState<Record<string, boolean>>({});

  const resetWizard = () => {
    setWizardStep(0);
    setWizardData({});
    setOverride({});
    setInitialOverride({});
    setCompanyOverride({});
    setInitialCompanyOverride({});
  };

  return {
    wizardStep,
    setWizardStep,
    wizardData,
    setWizardData,
    companyMode,
    setCompanyMode,
    override,
    setOverride,
    initialOverride,
    setInitialOverride,
    companyOverride,
    setCompanyOverride,
    initialCompanyOverride,
    setInitialCompanyOverride,
    resetWizard,
  };
};